import React from 'react';
import { ButtonComp } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import { modifyData } from '../HeaderUtilities/HeaderUtils';
import { AnchorWithLink } from 'atoms/Anchor';
import HEADER_CONSTANT from '../HeaderConstants/HeaderConstant';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { getValueOrDefaultObject, getValueOrDefaultAlternativeObject } from 'common/utilities/utils';
import { Config, ROUTE_URL } from 'common/constants/SharedConstants';
import { login } from 'common/utilities/LoginUtils';

const SecondaryHeaderItems = props => {
  const {
    contentData = {},
    isMobile = false,
    userParams = {},
    tenantReducerData = {},
    paymentHeader = false,
    checkoutHeader = false,
    navigateHandler = null,
    history,
  } = props;

  const { basic } = tenantReducerData;

  const { LOGGEDIN_USER_SINGIN_TEXT, BACK_TO_CART, Go_TO_HOME_PAGE } = HEADER_CONSTANT;

  const { ArrowIcon, HeaderLogo } = IMAGE_PATH;

  const { navRight = [], kfcLogo = {} } = getValueOrDefaultObject(modifyData(contentData, basic));

  /* Sign in button click */
  const signInClick = (signInObj, userParams) => {
    if (userParams.loggedIn) {
      history.push({
        pathname: '/account',
      });
    } else {
      login();
    }
  };

  const signInStatusElmnt = () => {
    let signInObj = null;
    if (navRight && navRight.length) {
      // eslint-disable-next-line array-callback-return
      signInObj = navRight.filter(item => {
        if (item.name === 'Sign In') {
          return item;
        }
      })[0];
    }
    return (
      signInObj && (
        <div
          className='signinLink ml-4'
          data-testid='SignIn'
          tabIndex='0'
          onClick={() => signInClick(signInObj, userParams)}
        >
          <ImageComponent
            data-id={Config.CHECKOUT_SIGN_IN_ATTR_DATA_ID}
            srcFile={signInObj.url || signInObj.imageUrl}
            className='navRightIcons'
          />
          {!isMobile && (
            <span className='notcarticon'>
              {signInObj.name && userParams.loggedIn ? LOGGEDIN_USER_SINGIN_TEXT : signInObj.name}
            </span>
          )}
        </div>
      )
    );
  };

  const onClickButton = e => {
    e.stopPropagation();
    e.preventDefault();
    history.push({
      pathname: '/cart',
    });
  };
  const onClick = e => {
    e.stopPropagation();
    e.preventDefault();
    localStorage.setItem('orderComplete', true);
    history.push({
      pathname: '/',
    });
  };

  return (
    <>
      {checkoutHeader && (
        <div className='d-flex align-items-center justify-content-between secondaryChekoutheader'>
          <div className='secondary-header-element'>
            {!isMobile ? (
              <ButtonComp
                className='button whiteButton blackBorder'
                onClickHandler={e => onClickButton(e)}
                data-testid='Back-Button-checkout'
                ariaLable={translateWithI18Next(BACK_TO_CART)}
              >
                {translateWithI18Next(BACK_TO_CART)}
              </ButtonComp>
            ) : (
              <ButtonComp className='btn' onClickHandler={e => onClickButton(e)}>
                <ImageComponent srcFile={ArrowIcon} alt={'Back to Cart'} />
              </ButtonComp>
            )}
          </div>
          <AnchorWithLink
            className='headerLogo secondary'
            data-testid='desktop-navigate-handler'
            onClickHandler={navigateHandler}
          >
            <span>
              {!isMobile ? (
                <ImageComponent
                  srcFile={getValueOrDefaultAlternativeObject(kfcLogo.src, HeaderLogo)}
                  alt={getValueOrDefaultAlternativeObject(kfcLogo.alt, 'KFC LOGO')}
                />
              ) : (
                <h3 className='textualLogo'>{translateWithI18Next('cartCheckout')}</h3>
              )}
            </span>
          </AnchorWithLink>

          <div className='d-flex secondary-header-element'>
            <AnchorWithLink className='needHelpDesk' href={'/help'}>
              <span aria-hidden='true' className='roundedQmark'>
                ?
              </span>
              {!isMobile && <label className='needHelp'>Need Help?</label>}
            </AnchorWithLink>
            {signInStatusElmnt()}
          </div>
        </div>
      )}
      {paymentHeader && (
        <div className='payment-header'>
          {isMobile ? (
            <div className='headerItems'>
              <span>
                <AnchorWithLink className='needHelpDeskClose' href={ROUTE_URL.HOME_PAGE}>
                  <span className='backIcon'>
                    <img src={ArrowIcon} alt='back-btn' />
                  </span>
                </AnchorWithLink>
              </span>
              <span className='TrackOrder'>Track Order</span>
              <span>
                <AnchorWithLink className='needHelpDesk' href={ROUTE_URL.HELP}>
                  <span className='roundedQuesmark'>?</span>
                </AnchorWithLink>
              </span>
            </div>
          ) : (
            <div className='d-flex align-items-center justify-content-between payment-header-content'>
              <div className='secondary-header-element'>
                <ButtonComp
                  className='button whiteButton blackBorder'
                  onClickHandler={e => onClick(e)}
                  data-testid='Back-Button'
                  ariaLable={translateWithI18Next(Go_TO_HOME_PAGE)}
                >
                  {translateWithI18Next(Go_TO_HOME_PAGE)}
                </ButtonComp>
              </div>
              <div>
                <span className='headerLogo paymentHeader' tabIndex='0' onClick={navigateHandler}>
                  <ImageComponent
                    srcFile={getValueOrDefaultAlternativeObject(kfcLogo.src, HeaderLogo)}
                    alt={getValueOrDefaultAlternativeObject(kfcLogo.alt, 'KFC LOGO')}
                  />
                </span>
              </div>
              <div className='d-flex secondary-header-element'>
                <AnchorWithLink className='needHelpDesk' href={'/help'}>
                  <span aria-hidden='true' className='roundedQmark'>
                    ?
                  </span>
                  {!isMobile && <label className='needHelp'>Need Help?</label>}
                </AnchorWithLink>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default SecondaryHeaderItems;
